import React, { useMemo, useState, useEffect } from "react";
import { Button, Col, Form, Input, Label, Row } from "reactstrap";
import ToastAlert from "../../Components/Common/ToastAlert";
import { APIClient } from "../../helpers/api_helper";

const QuickAddJob = ({ toggleModal, isModalOpen, getJobList }) => {
    const api = useMemo(() => new APIClient(), []);

    const [item, setItem] = useState({ fk_company_id: "", title: "", fk_input_id: "" });
    const [inputs, setInputs] = useState([]);

    useEffect(() => {
        const fetchInputs = async () => {
            try {
                const res = await api.get("v1/inputs/?page=1");
                if (res && res.data && Array.isArray(res.data)) setInputs(res.data);
                else if (Array.isArray(res)) setInputs(res);
                else if (res && Array.isArray(res.results)) setInputs(res.results);
            } catch (e) {
                // sessiz geç
            }
        };
        fetchInputs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [modalError, setModalError] = useState([]);

    const handleModalClick = (e) => {
        if (e.target.classList.contains("modal")) {
            toggleModal();
        }
    };

    const formValidation = () => {
        if (item.fk_company_id === "") {
            setModalError(["fk_company_id"]);
            return false;
        }
        if (item.title === "") {
            setModalError(["title"]);
            return false;
        }
        if (item.fk_input_id === "") {
            setModalError(["fk_input_id"]);
            return false;
        }
        setModalError([]);
        return true;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formValidation()) {
            api
                .create("v1/jobs/", { ...item, fk_input_id: Number(item.fk_input_id) })
                .then(() => getJobList())
                .then(() => {
                    toggleModal();
                    ToastAlert("Job added successfully.", "success");
                })
                .catch((error) => {
                    if (error && typeof error === "object") {
                        Object.keys(error).forEach((key) => {
                            ToastAlert(error[key], "error");
                        });
                    } else {
                        ToastAlert(error, "error");
                    }
                });
        } else {
            ToastAlert("Please fill in required fields.", "warning");
        }
    };

    return (
        <React.Fragment>
            <div className={`modal fade ${isModalOpen ? "show" : ""}`} id="quickAddJob" tabIndex="-1" role="dialog" style={{ display: isModalOpen ? "block" : "none" }} onClick={handleModalClick}>
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0">
                            <h5 className="modal-title">Quick Add Job</h5>
                            <button type="button" className="btn-close" onClick={toggleModal}></button>
                        </div>
                        <div className="modal-body">
                            <div className="row g-3">
                                <Form onSubmit={handleSubmit}>
                                    <Row className={"mb-3"}>
                                        <Col xxl={6}>
                                            <Label htmlFor="fk_company_id" className="form-label">
                                                Company ID <span className={"text-danger"}>(*)</span>
                                            </Label>
                                            <Input type="text" autoFocus={true} className={"form-control " + (modalError.includes("fk_company_id") ? "is-invalid" : "")} id="fk_company_id" placeholder="Company ID" value={item.fk_company_id} onChange={(e) => setItem({ ...item, fk_company_id: e.target.value })} />
                                        </Col>
                                        <Col xxl={6}>
                                            <Label htmlFor="title" className="form-label">
                                                Title <span className={"text-danger"}>(*)</span>
                                            </Label>
                                            <Input type="text" id="title" className={"form-control " + (modalError.includes("title") ? "is-invalid" : "")} value={item.title} onChange={(e) => setItem({ ...item, title: e.target.value })} placeholder="Title" />
                                        </Col>
                                    </Row>
                                    <Row className={"mb-3"}>
                                        <Col xxl={6}>
                                            <Label htmlFor="fk_input_id" className="form-label">
                                                Input <span className={"text-danger"}>(*)</span>
                                            </Label>
                                            <Input type="select" id="fk_input_id" className={"form-control " + (modalError.includes("fk_input_id") ? "is-invalid" : "")} value={item.fk_input_id} onChange={(e) => setItem({ ...item, fk_input_id: e.target.value })}>
                                                <option value="">Select</option>
                                                {inputs.map((inp) => (
                                                    <option key={inp.id} value={inp.id}>{inp.keyword} ({inp.location})</option>
                                                ))}
                                            </Input>
                                        </Col>
                                    </Row>
                                    <Col lg={12}>
                                        <div className="hstack gap-2 justify-content-end">
                                            <Button type="button" className="btn btn-light" onClick={toggleModal}>
                                                Cancel
                                            </Button>
                                            <Button type="submit" className="btn btn-primary">
                                                Save
                                            </Button>
                                        </div>
                                    </Col>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isModalOpen && <div className="modal-backdrop fade show"></div>}
        </React.Fragment>
    );
};

export default QuickAddJob;


